'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _regenerator = require('babel-runtime/regenerator');
var _regenerator2 = _interopRequireDefault(_regenerator);
var _jsxFileName = 'src/components/login-form.js';
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _button = require('@marmalade/button');
var _button2 = _interopRequireDefault(_button);
var _updateFields = require('@marmalade/form/lib/actions/update-fields');
var _form = require('@marmalade/form/lib/components/form');
var _form2 = _interopRequireDefault(_form);
var _input = require('@marmalade/form/lib/components/input');
var _input2 = _interopRequireDefault(_input);
var _password = require('@marmalade/form/lib/questions/password');
var _password2 = _interopRequireDefault(_password);
var _loading = require('@marmalade/loading');
var _loading2 = _interopRequireDefault(_loading);
var _message = require('@marmalade/message');
var _message2 = _interopRequireDefault(_message);
var _propTypes = require('@marmalade/prop-types');
var _axios = require('axios');
var _axios2 = _interopRequireDefault(_axios);
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _propTypes2 = require('prop-types');
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _reactRouterDom = require('react-router-dom');
var _girlAtDesk = require('../../images/girl-at-desk.svg');
var _girlAtDesk2 = _interopRequireDefault(_girlAtDesk);
var _actions = require('../actions');
var _constants = require('../constants');
var _selectors = require('../selectors');
var _validation = require('../validation');
var _accountPanel = require('./account-panel');
var _accountPanel2 = _interopRequireDefault(_accountPanel);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var formId = _constants.forms.login;
var LoginForm = function (_Component) {
  _inherits(LoginForm, _Component);
  function LoginForm() {
    var _ref,
      _this2 = this;
    var _temp, _this, _ret;
    _classCallCheck(this, LoginForm);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LoginForm.__proto__ || Object.getPrototypeOf(LoginForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      quickQuote: false,
      aggregator: false
    }, _this.handleSubmit = function () {
      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(formState) {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!formState.validAndPristine) {
                  _context.next = 9;
                  break;
                }
                _context.t0 = _this.props;
                _context.t1 = _this.props.product;
                _context.t2 = formState.values.username;
                _context.t3 = formState.values.password;
                _context.next = 7;
                return sha256(formState.values.username);
              case 7:
                _context.t4 = _context.sent;
                _context.t0.login.call(_context.t0, _context.t1, _context.t2, _context.t3, _context.t4);
              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(LoginForm, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.loggedIn) {
        this.props.history.push(this.props.redirect);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.logout();

      // Little hack to help returning NDI customers
      var query = this.props.query;
      if (query.reason && query.reason === 'aggregator') {
        this.setState({
          aggregator: true,
          quickQuote: false
        });
      } else if (query.quickquote && query.quickquote === '1') {
        this.setState({
          quickQuote: true,
          aggregator: false
        });
      }

      // Little hack for clearing internal NDI sessions
      if (this.props.product === 'ndi') {
        _axios2.default.get('/new/stage1?clearsession').catch(function () {});
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.loggedIn) {
        this.props.history.push(this.props.redirect);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.resetFields(formId, ['password']);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_accountPanel2.default, {
        img: _girlAtDesk2.default,
        alt: 'Girl at desk',
        icon: 'lock',
        title: 'Log in',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 100
        },
        __self: this
      }, this.state.quickQuote || this.state.aggregator ? _react2.default.createElement(_message2.default, {
        type: 'help',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 102
        },
        __self: this
      }, this.state.aggregator ? _react2.default.createElement('div', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 104
        },
        __self: this
      }, 'Hey there! We\'ve noticed that you have previously had a quotation from Marmalade on the uSwitch website. You can recover your previous quotation if you login below using the account details that we\'ve just sent to your email address.') : _react2.default.createElement('div', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 110
        },
        __self: this
      }, 'Hey there! We\'ve noticed that you have previously had a quotation from Marmalade. You can recover your previous quote by logging in below using the account details we sent to your email address.')) : null, _react2.default.createElement(_form2.default, {
        id: formId,
        handleSubmit: this.handleSubmit,
        validator: _validation.loginValidator,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 118
        },
        __self: this
      }, this.props.loginError ? _react2.default.createElement(_message2.default, {
        type: 'warning',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 119
        },
        __self: this
      }, this.props.loginError) : null, _react2.default.createElement(_input2.default, {
        label: 'Username/email',
        name: 'username',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 120
        },
        __self: this
      }), _react2.default.createElement(_password2.default, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 121
        },
        __self: this
      }), _react2.default.createElement(_glamorous2.default.Div, {
        css: {
          textAlign: 'center'
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 122
        },
        __self: this
      }, this.props.isLoggingIn ? _react2.default.createElement(_loading2.default, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 124
        },
        __self: this
      }) : _react2.default.createElement(_button2.default, {
        type: 'submit',
        prominence: 'primary',
        text: 'Log in',
        block: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 126
        },
        __self: this
      }), _react2.default.createElement(_reactRouterDom.Link, {
        to: '/reset-password',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 128
        },
        __self: this
      }, 'Forgotten your password?'))));
    }
  }]);
  return LoginForm;
}(_react.Component);
LoginForm.propTypes = {
  // user
  product: _propTypes.product.isRequired,
  // withRouter
  history: _propTypes.history.isRequired,
  location: _propTypes.location.isRequired,
  // dtp
  logout: _propTypes2.func.isRequired,
  login: _propTypes2.func.isRequired,
  resetFields: _propTypes2.func.isRequired,
  // stp
  isLoggingIn: _propTypes2.bool.isRequired,
  loginError: _propTypes2.string.isRequired,
  loggedIn: _propTypes2.bool.isRequired,
  redirect: _propTypes2.string.isRequired,
  query: _propTypes2.object.isRequired
};
exports.default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(function (state) {
  return {
    isLoggingIn: (0, _selectors.isLoggingIn)(state),
    loginError: (0, _selectors.loginError)(state),
    loggedIn: (0, _selectors.isLoggedIn)(state),
    query: state.query
  };
}, {
  login: _actions.login,
  logout: _actions.logout,
  resetFields: _updateFields.resetFields,
  setValue: _updateFields.setValue
})(LoginForm));
var sha256 = function () {
  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(input) {
    var encodedInput, hashBuffer, hashArray, hashHex;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            encodedInput = new TextEncoder().encode(input);
            _context2.next = 4;
            return crypto.subtle.digest('SHA-256', encodedInput);
          case 4:
            hashBuffer = _context2.sent;
            hashArray = Array.from(new Uint8Array(hashBuffer));
            hashHex = hashArray.map(function (bytes) {
              return bytes.toString(16).padStart(2, '0');
            }).join('');
            return _context2.abrupt('return', hashHex);
          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2['catch'](0);
            return _context2.abrupt('return', undefined);
          case 13:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined, [[0, 10]]);
  }));
  return function sha256(_x2) {
    return _ref3.apply(this, arguments);
  };
}();